import buildRoute from './buildRoute'

export const getDisplays = async (active: boolean) => {
    try {
        const res: any = await buildRoute({
            type: 'post',
            route: 'displays',
            data: { active },
        })
        if (res.data) return res.data
    } catch (err: any) {
        return console.error(err)
    }
}

export const addDisplay = async (formData: any) => {
    try {
        const res: any = await buildRoute({
            type: 'post',
            route: 'display',
            data: formData,
        })
        if (res.data) return res
    } catch (err: any) {
        console.error(err)
        return err
    }
}

interface SelectionType {
    displays: any[]
    activate?: boolean
}

export const deactivateDisplays = async (selection: SelectionType) => {
    try {
        const res: any = await buildRoute({
            type: 'post',
            route: 'display-activations',
            data: selection,
        })
        if (res.data) return res
    } catch (err: any) {
        console.error(err)
        return err
    }
}

export const deleteDisplays = async (selection: SelectionType) => {
    try {
        const res: any = await buildRoute({
            type: 'post',
            route: 'display-deletion',
            data: selection,
        })
        if (res.data) return res
    } catch (err: any) {
        console.error(err)
        return err
    }
}

// multipart: "data" JSON string + "file"; see parseFormWithFile.
export const addDisplayFile = async (
    formData: FormData,
    onUploadProgress?: (percent: number) => void
) => {
    try {
        const res: any = await buildRoute({
            type: 'file',
            route: 'displayFileUpload',
            data: formData,
            onUploadProgress,
        })
        if (res.data) return res
    } catch (err: any) {
        console.error(err)
        return err
    }
}

export const deleteBlobDisplayFile = async (formData: {
    title: string
    etag: string
}) => {
    try {
        const res: any = await buildRoute({
            type: 'post',
            route: 'delete-display-blob',
            data: formData,
        })
        if (res.data) return res
    } catch (err: any) {
        console.error(err)
        return err
    }
}

const displayRoutes = {
    getDisplays,
    addDisplay,
    deactivateDisplays,
    deleteDisplays,
    addDisplayFile,
    deleteBlobDisplayFile,
}

export default displayRoutes
